import { useTranslation } from 'next-i18next'

import LoaderSkeleton from '~/shared/components/LoaderSkeleton'
import StatsProgressBar from '~/statistics-v2/components/StatsProgressBar'
import { OverallProgressCardProps } from '~/statistics-v2/types/statistics.types'
import { calculateProgress } from '~/statistics-v2/utils/statistics.utils'

export default function OverallProgressCard({
  overallProgressCardProps,
  selectedGrade,
  isLoading = false,
}: {
  overallProgressCardProps: OverallProgressCardProps
  selectedGrade: { key: string; label: string }
  isLoading?: boolean
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  const { totalLevels, completedLevels } = overallProgressCardProps
  const progressPercentage = calculateProgress(completedLevels, totalLevels)

  const isSpecificGrade = selectedGrade.key !== '0' && selectedGrade.key !== 'all-math' && Boolean(selectedGrade.label)
  const progressLabel = isSpecificGrade
    ? t('gradeMathProgress', { grade: selectedGrade.label })
    : t('overallMathProgress')

  return (
    <div className="relative h-46 w-full lg:w-125 border rounded-6 border-purple/50 bg-purple-gdark overflow-hidden">
      {isLoading ? (
        <LoaderSkeleton className="absolute min-h-full min-w-full rounded-6 bg-transparent" randomStart speed={1200} />
      ) : (
        <div className="flex flex-col justify-between h-full w-full px-4 py-3">
          <p className="text-white text-sm font-bold leading-8">{progressLabel}</p>

          <StatsProgressBar
            barType="round"
            FirstSubtitle={`${progressPercentage}% Completed`}
            progressPercentage={progressPercentage}
          />
        </div>
      )}
    </div>
  )
}
